export default __webpack_public_path__ + "static/media/al-khawarizmi.d02bbbb1.jpg";